var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollarSimple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 137 78.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-13.04 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.31,52.57Q17.9,35.29,22.48,18a52.75,52.75,0,0,1,10.41-5.34c-8.19,5.16-7,11.38,1.24,17.88C47.9,41.44,66.54,57.2,81.27,69.93,86.44,74.44,91.13,78.5,95,81.87c-10.3.44-18.24,1-26.8,0C42.53,78.87,23.22,68.55,13.31,52.57Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-13.04 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.79,52.57Q145.22,35.29,140.62,18a52.75,52.75,0,0,0-10.41-5.34c8.2,5.16,7,11.38-1.24,17.88C115.2,41.44,96.57,57.2,81.84,69.93c-5.17,4.51-5.44,8.12-5.71,12.51A108.1,108.1,0,0,0,101.47,81c22.37-3.9,39.27-13.77,48.32-28.36Z",
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142,24.5c0,11-26.09,46.5-59.5,46.5S21,35.55,21,24.5s27.09-20,60.5-20S142,13.45,142,24.5Z",
    transform: "translate(-13.04 -4.5)",
    fill: "#404041"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.31,52.57Q17.9,35.29,22.48,18a52.75,52.75,0,0,1,10.41-5.34c-8.19,5.16-7,11.38,1.24,17.88C47.9,41.44,66.54,57.2,81.27,69.93,86.44,74.44,91.13,78.5,95,81.87c-10.3.44-18.24,1-26.8,0C42.53,78.87,23.22,68.55,13.31,52.57Z",
    transform: "translate(-13.04 -4.5)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.28,48.92,15.85,43A156.75,156.75,0,0,0,29.68,55.19C38,62.05,47.12,69.49,53.1,77.78l.4.85.16.6c-2.83-.72-5.55-1.55-8.17-2.47C40,70.57,33,64.74,26.31,59.28c-4.38-3.59-8.56-7-12-10.36Z",
    transform: "translate(-13.04 -4.5)",
    fill: "#404041",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9,35.27l2.6-9.83,1.62,3.91C26,35.88,35,43.28,44.81,51.35c10.7,8.77,22.31,18.29,30,28.9l.52,1.09.26,1.1c-2.7-.11-5.36-.33-8.16-.67C60.3,72.82,50,64.44,40.51,56.59,31.33,49.06,22.81,42.08,17.9,35.27Z",
    transform: "translate(-13.04 -4.5)",
    fill: "#404041",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.31,52.57Q17.9,35.29,22.48,18a52.75,52.75,0,0,1,10.41-5.34c-8.19,5.16-7,11.38,1.24,17.88C47.9,41.44,66.54,57.2,81.27,69.93,86.44,74.44,91.13,78.5,95,81.87c-10.3.44-18.24,1-26.8,0C42.53,78.87,23.22,68.55,13.31,52.57Z",
    transform: "translate(-13.04 -4.5)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.79,52.57Q145.22,35.29,140.62,18a52.75,52.75,0,0,0-10.41-5.34c8.2,5.16,7,11.38-1.24,17.88C115.2,41.44,96.57,57.2,81.84,69.93c-5.17,4.51-5.44,8.12-5.71,12.51A108.1,108.1,0,0,0,101.47,81c22.37-3.9,39.27-13.77,48.32-28.36Z",
    transform: "translate(-13.04 -4.5)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.83,48.92,147.25,43a152.26,152.26,0,0,1-13.82,12.19C125,62.05,116,69.49,110,77.78l-.41.85-.16.6c2.83-.72,5.56-1.55,8.17-2.47,5.42-6.19,12.53-12,19.18-17.48,4.38-3.59,8.57-7,12-10.36Z",
    transform: "translate(-13.04 -4.5)",
    fill: "#404041",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.21,35.27l-2.61-9.83L141,29.35c-3.85,6.53-12.88,13.93-22.69,22C107.59,60.12,96,69.64,88.34,80.25l-.52,1.09-.31,1.1c2.7-.11,5.36-.33,8.16-.67,7.13-9,17.4-17.4,26.93-25.21,9.17-7.53,17.69-14.51,22.61-21.32Z",
    transform: "translate(-13.04 -4.5)",
    fill: "#404041",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.79,52.57Q145.22,35.29,140.62,18a52.75,52.75,0,0,0-10.41-5.34c8.2,5.16,7,11.38-1.24,17.88C115.2,41.44,96.57,57.2,81.84,69.93c-5.17,4.51-5.44,8.12-5.71,12.51A108.1,108.1,0,0,0,101.47,81c22.37-3.9,39.27-13.77,48.32-28.36Z",
    transform: "translate(-13.04 -4.5)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollarSimple);
export default __webpack_public_path__ + "static/media/collar-simple.fb7984b1feeb2c3d4f8efdf41fa06e2f.svg";
export { ForwardRef as ReactComponent };